import { Component, inject } from '@angular/core';
import { ButtonsModule, DialogModule, DialogService, IconModule, PanelModule, SnackBarService } from '@mastechnicaegroup/carelinelive-ui';
import { DIALOG_DATA, DialogRef } from '@angular/cdk/dialog';
import { SendableRequest } from '@mastechnicaegroup/carelinelive-cdk/requests';
import { StoreSystemAdminRequest, SystemAdmin, SystemAdminSingleResponse, User } from '@lib/api/models/user';
import { UserService } from '@lib/user/user.service';

@Component({
    selector: 'app-prompt-system-admin-remove-dialog',
    imports: [
        ButtonsModule,
        DialogModule,
        IconModule,
        PanelModule
    ],
    templateUrl: './prompt-system-admin-remove-dialog.component.html',
    standalone: true,
    styleUrl: './prompt-system-admin-remove-dialog.component.scss'
})
export class PromptSystemAdminRemoveDialogComponent {
    protected readonly dialogRef = inject<DialogRef>(DialogRef);
    private readonly _userService = inject(UserService);
    private readonly _snackBar = inject(SnackBarService);
    protected readonly user = inject<User>(DIALOG_DATA);

    removeSystemAdminRequest = new SendableRequest<SystemAdminSingleResponse, StoreSystemAdminRequest>({
        request: (payload) => this._userService.removeSystemAdmin(payload!),
        onSuccess: () => {

            this._snackBar.open({
                colour: 'success',
                dismissable: false,
                icon: 'check_circle',
                title: 'System Admin remove successfully',
                actions: [
                    { id: 'undo', label: 'OK' }
                ]
            });

            this.dialogRef.close();
        },
        onError: () => {
            this._snackBar.open({
                colour: 'error',
                dismissable: false,
                icon: 'error_outline',
                title: 'Failed to remove System Admin',
                actions: [
                    { id: 'undo', label: 'OK' }
                ]
            });
        }
    });

    remove() {
        this.removeSystemAdminRequest.send({
            id: this.user?.id || ''
        });
    }

    public static show(dialog: DialogService, data: SystemAdmin) {
        return dialog.openDialog<DialogRef, SystemAdmin>(PromptSystemAdminRemoveDialogComponent, {
                data
            }
        );
    }
}
